import { useLocation } from "react-router-dom";
import { APP_PREFIX_PATH, AUTHENTICATED_ENTRY } from "configs/AppConfig";

export const CHAT_PATH = `${APP_PREFIX_PATH}/chat-erp`;
const BACKGROUND_STORAGE_KEY = "med-chat-background";
const DEFAULT_BACKGROUND = { pathname: AUTHENTICATED_ENTRY, search: "", hash: "" };

// Trang ERP đứng phía sau khi chat mở dạng modal.
//
// Nút chat điều hướng sang /app/chat-erp kèm state.backgroundLocation, nhưng ChatModule tự
// navigate sang /app/chat-erp/:conversationId khi bấm vào hội thoại và KHÔNG mang theo state.
// Nếu chỉ đọc state thì modal sẽ biến mất giữa chừng, nên phải nhớ lại trang nền: giữ ở phạm vi
// module để layout (render trước) và Routes (render sau) trong cùng một lượt luôn thấy cùng giá
// trị; rời khỏi URL chat thì xoá.
//
// Biến module KHÔNG sống sót qua F5 (JS nạp lại từ đầu), và location.state của React Router
// cũng không đáng tin cậy để phục hồi sau F5 (nhất là ở URL hội thoại con /app/chat-erp/:id,
// nơi vốn dĩ chưa từng có backgroundLocation trong state để mà phục hồi). Nên mỗi khi có
// backgroundLocation mới, ghi thêm ra sessionStorage - đọc lại ở closeChatModalOnReload bên
// dưới.
let lastBackgroundLocation = null;

// F5 khi đang mở modal chat -> đóng modal, quay về đúng trang ERP nền. Modal chỉ là trạng thái
// tạm của một phiên SPA: reload thì coi như đóng modal, quay lại đúng trang nền - không cố giữ
// modal sống lại sau F5.
// Gọi ở src/index.js TRƯỚC KHI React render (dùng window.location/history.replaceState thẳng,
// chưa có Router) - nên chat không kịp nhấp nháy rồi mới chuyển trang.
// Không tìm ra trang nền (mở thẳng URL chat ở tab mới, hoặc sessionStorage đã bị xoá) -> giữ
// nguyên URL, hiển thị trang chat độc lập (views/app-views/chat-erp/index.js) như cũ.
export const closeChatModalOnReload = () => {
  if (!window.location.pathname.startsWith(CHAT_PATH)) return;

  const background = sessionStorage.getItem(BACKGROUND_STORAGE_KEY);
  // Chặn trang nền lại trỏ về chính chat (dữ liệu cũ/hỏng) -> tránh mở lại modal vô nghĩa.
  if (!background || background.startsWith(CHAT_PATH)) return;

  window.history.replaceState(null, "", background);
};

const useBackgroundLocation = () => {
  const location = useLocation();
  const isChatUrl = location.pathname.startsWith(CHAT_PATH);

  if (!isChatUrl) {
    lastBackgroundLocation = null;
    sessionStorage.removeItem(BACKGROUND_STORAGE_KEY);
  } else if (location.state?.backgroundLocation) {
    lastBackgroundLocation = location.state.backgroundLocation;
    const { pathname, search = "", hash = "" } = lastBackgroundLocation;
    sessionStorage.setItem(BACKGROUND_STORAGE_KEY, `${pathname}${search}${hash}`);
  } else if (!lastBackgroundLocation) {
    lastBackgroundLocation = DEFAULT_BACKGROUND;
    sessionStorage.setItem(BACKGROUND_STORAGE_KEY, AUTHENTICATED_ENTRY);
  }

  return isChatUrl ? lastBackgroundLocation : null;
};

export default useBackgroundLocation;
